import { Asset } from '../../../../types/Asset'
import {
  CurrencyEnum,
  numberToCurrency,
} from '../../../../utils/numberToCurrency'

export const formatAssetAmount = (asset: Asset) => {
  switch (asset.currency) {
    case CurrencyEnum.usd:
      return numberToCurrency(asset.amount, CurrencyEnum.usd)
    case CurrencyEnum.cad:
      return numberToCurrency(asset.amount, CurrencyEnum.cad)
    default:
      return asset.amount.toFixed(2)
  }
}
